import { ESearchFilters } from '@/constants/searchFilters';

// Converts snake_case and kebab-case to camelCase
export const toCamelCase = (text: string) => {
  return text.replace(/([-_][a-z])/gi, s => {
    return s.toUpperCase().replace('-', '').replace('_', '');
  });
};

export const camelToSnakeCase = (text: string) => {
  return text.replace(/([A-Z])/g, '_$1').toLowerCase();
};

export const normalizeSearchFilterKey = (key: string): string => {
  // Attempt to match a filter key from ESearchFilters regardless of case (key in camel or snake case/value in snake case)
  // as keys could be coming from the cms or elsewhere
  // and the UI won't recognise them necessarily as valid but we still need to pass them to search

  // check keys in ESearchFilters enum
  const enumKey = Object.keys(ESearchFilters).find(k => k.toLowerCase() === key.toLowerCase());
  if (enumKey) {
    return ESearchFilters[enumKey as keyof typeof ESearchFilters];
  }

  // check values in ESearchFilters enum
  const enumValue = Object.values(ESearchFilters).find(v => v.toLowerCase() === key.toLowerCase());
  if (enumValue) {
    return enumValue;
  }

  // if no match found, return the original key
  return key;
};
